//
import React, { Component } from "react"
import PropTypes from "prop-types"

import isFeatureEnabled from "shared/featureflags/helperFunctions"

import { federalRegions, federalAndStates, euRegion, usAndCanadaRegions } from "shared/imports/regionConstants"

import {
    addressGenericFilter,
    createProfileToggleFilter,
    textGenericFilter,
    // sorting functions
    enumValueSort,
    enumOrderSort,
    enumLabelSort,
    // enumLabelSort,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    enumCompositeStringFilter,
    toggleGenericFilter,
    searchifySelectGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    CommitteeFilterableListView,
    CaucusFilterableListView,
    ExecutiveSearchifyFLV,
    StafferTitleSearchifyFLV,
    StafferTermSearchifyFLV,
    BulkUploadFileFLV,
    IssueManagementFilterableListView,
    OfficialFilterableListView,
    LegislatorSearchifyWithoutCampaignFinanceFLV,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    CustomEventSelect,
    ExecutiveSelect,
    CommitteeSelect,
    StafferTitleSelect,
    StafferTermSelect,
    CaucusSelect,
    IssueManagementSelect,
    BulkUploadFileSelect,
    OfficialSelect,
    LegislatorSelectWithoutCampaignFinance,
} from "app/static/frontend/selects/containers/PieSelect"

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}

export class StafferTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "stafferTypeFilter",
        filterKey: "ph_minor_role_type",
        enumItems: DjangIO.app.person.newtypes.MinorRoleType.region_supported_items(),
        enumGroups: DjangIO.app.person.newtypes.MinorRoleType.filter_groups.filter((group) =>
            [
                "Staff",
                "Legislative Staff",
                "Leadership Staff",
                "Committee Staff",
                "Executive Staff",
                "Campaign Staff",
            ].includes(group.title),
        ),
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferTypeNewFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "stafferTypeNewFilter",
        filterKey: "for_staffer_types",
        displayLabel: DjangIO.app.models.QuorumDataType.staffer.plural,
        enumItems: DjangIO.app.person.types.StafferType.region_supported_items(),
        sortBy: enumLabelSort,
        regions: euRegion,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferWorksForOfficialEUFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferWorksForOfficialEUFilter",
            filterKey: "members",
            searchifyFLV: OfficialFilterableListView,
            displayLabel: "Works For (Official)",
            dataTypeLabel: "Official",
            selectComponent: OfficialSelect,
            regions: euRegion,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferLegislatorFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferLegislatorFilter",
            filterKey: "members",
            searchifyFLV: LegislatorSearchifyWithoutCampaignFinanceFLV,
            displayLabel: "Works For",
            dataTypeLabel: "Legislator",
            selectComponent: LegislatorSelectWithoutCampaignFinance,
            helpText:
                "When filtering for staff who work for a legislator, you will see committee and " +
                "leadership staff on committees where the legislator is the chair or ranking member, " +
                "in addition to the legislative staff who work for the legislator. Use the staffer type " +
                "filter above to filter for specific types of staff (e.g. Legislative vs Committee).",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferExecutiveFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferExecutiveFilter",
            filterKey: "executives",
            searchifyFLV: ExecutiveSearchifyFLV,
            dataTypeLabel: "Executive",
            selectComponent: ExecutiveSelect,
            regions: federalAndStates,
            permissions: [DjangIO.app.models.PermissionType.executives],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferCommitteeFilter",
            filterKey: "staffer_works_for_committee",
            searchifyFLV: CommitteeFilterableListView,
            dataTypeLabel: "Committee",
            selectComponent: CommitteeSelect,
            regions: federalAndStates,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferCaucusFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferCaucusFilter",
            filterKey: "staffer_works_for_caucus",
            searchifyFLV: CaucusFilterableListView,
            dataTypeLabel: "Caucus",
            selectComponent: CaucusSelect,
            regions: federalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferOfficeLocationFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "stafferOfficeFilter",
        filterKey: "is_capitol_office",
        displayLabel: "Office Location",
        trueText: "Capitol Office",
        falseText: "District Office",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferChamberFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "stafferChamberFilter",
        filterKey: "staffer_chamber",
        enumItems: DjangIO.app.models.CongressChamber.region_supported_items().filter(
            (item) => item.value !== DjangIO.app.models.CongressChamber.both.value,
        ),
        displayLabel: "Chamber",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferPartyFilter extends Component {
    static defaultProps = {
        filterComponent: enumCompositeStringFilter,
        uniqueFilterId: "stafferPartyFilter",
        filterKey: "most_recent_party__in",
        displayLabel: "Party",
        enumItems: DjangIO.app.person.types.Party.region_supported_items()
            .filter((item) => item.value !== DjangIO.app.person.types.Party.NoParty.value)
            .map((item) => ({
                ...item,
                value:
                    item.value === DjangIO.app.person.types.Party.Democrat.value
                        ? [
                              DjangIO.app.person.types.Party.Democrat.value.toString(),
                              DjangIO.app.person.types.Party.ppd.value.toString(),
                          ]
                        : item.value === DjangIO.app.person.types.Party.Republican.value
                          ? [
                                DjangIO.app.person.types.Party.Republican.value.toString(),
                                DjangIO.app.person.types.Party.pnp.value.toString(),
                            ]
                          : item.value.toString(),
            })),
        sortBy: enumOrderSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferRolesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferRolesFilter",
            filterKey: "staffer_titles",
            searchifyFLV: StafferTitleSearchifyFLV,
            dataTypeLabel: "Roles",
            displayLabel: Userdata.isOnlyStatesMode() ? "Choose Roles" : "Choose Roles & Issues",
            selectComponent: StafferTitleSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferIssuesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferIssuesFilter",
            filterKey: "staffer_issues",
            searchifyFLV: StafferTermSearchifyFLV,
            dataTypeLabel: "Issues",
            regions: federalRegions,
            selectComponent: StafferTermSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferFromBulkUploadFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "stafferFromBulkUploadFilter",
            filterKey: "from_bulk_upload_files",
            searchifyFLV: BulkUploadFileFLV,
            searchifyPermanentFilter: {
                upload_type: DjangIO.app.custom_data.types.BulkUploadType.staffer.value,
                status: DjangIO.app.custom_data.types.BulkUploadStatus.finished.value,
            },
            dataTypeLabel: `${DjangIO.app.models.QuorumDataType.staffer.plural} Bulk Uploads`,
            displayLabel: "Bulk upload files...",
            selectComponent: BulkUploadFileSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class StafferRepresentingAddressFilter extends Component {
    static defaultProps = {
        filterComponent: addressGenericFilter,
        uniqueFilterId: "stafferReppingAddress",
        displayLabel: "Representing an Address Or Region",
        filterKey: "representing_address",
        placeholderText: "Search for an address...",
        regions: usAndCanadaRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const StafferEmailFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
StafferEmailFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    placeholderText: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
StafferEmailFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "stafferEmailFilter",
    filterKey: "email_search",
    placeholderText: "Search by email address...",
    displayLabel: "Search by Email Address",
    helpText: "You can search for text contained in multiple email addresses by separating your inputs with a comma",
}

export const StafferProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={IssueManagementFilterableListView} {...props} />
}
StafferProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
StafferProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "stafferProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export const StafferCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferCustomEventFilter.propTypes = defaultPropTypes
StafferCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "stafferCustomEventFilter",
    filterKey: "staffers_involved_in_event_searchify",
    dataTypeLabel: "Added to Event",
    displayLabel: "Added to Event",
    selectComponent: CustomEventSelect,
}

export const StafferInvitedToEventCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferInvitedToEventCustomEventFilter.propTypes = defaultPropTypes
StafferInvitedToEventCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "StafferInvitedToEventCustomEventFilter",
    filterKey: "staffers_invited_to_event_searchify",
    dataTypeLabel: "Emailed About Event",
    displayLabel: "Emailed About Event",
    selectComponent: CustomEventSelect,
}

export const StafferHasNotRsvpCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferHasNotRsvpCustomEventFilter.propTypes = defaultPropTypes
StafferHasNotRsvpCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "StafferHasNotRsvpCustomEventFilter",
    filterKey: "staffers_has_not_rsvped_searchify",
    dataTypeLabel: "Has Not not RSVP'd to Event",
    displayLabel: "Has Not RSVP'd to Event",
    selectComponent: CustomEventSelect,
}

export const StafferHasRsvpYesCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferHasRsvpYesCustomEventFilter.propTypes = defaultPropTypes
StafferHasRsvpYesCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "StafferHasRsvpYesCustomEventFilter",
    filterKey: "staffers_has_rsvped_yes_searchify",
    dataTypeLabel: "RSVP'd Yes to Event",
    displayLabel: "RSVP'd Yes to Event",
    selectComponent: CustomEventSelect,
}

export const StafferHasRsvpNoCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferHasRsvpNoCustomEventFilter.propTypes = defaultPropTypes
StafferHasRsvpNoCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "StafferHasRsvpNoCustomEventFilter",
    filterKey: "staffers_has_rsvped_no_searchify",
    dataTypeLabel: "RSVP'd No to Event",
    displayLabel: "RSVP'd No to Event",
    selectComponent: CustomEventSelect,
}

export const StafferHasRsvpMaybeCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferHasRsvpMaybeCustomEventFilter.propTypes = defaultPropTypes
StafferHasRsvpMaybeCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "StafferHasRsvpMaybeCustomEventFilter",
    filterKey: "staffers_has_rsvped_maybe_searchify",
    dataTypeLabel: "RSVP'd Maybe to Event",
    displayLabel: "RSVP'd Maybe to Event",
    selectComponent: CustomEventSelect,
}

export const StafferAttendedCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
StafferAttendedCustomEventFilter.propTypes = defaultPropTypes
StafferAttendedCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "StafferAttendedCustomEventFilter",
    filterKey: "staffers_attended_event_searchify",
    dataTypeLabel: "Attended Event",
    displayLabel: "Attended Event",
    selectComponent: CustomEventSelect,
}

export const StafferCommitteeProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "stafferCommitteeProfileFilter",
    trueText: "Committee + All Sub Committees",
    falseText: "Current Committee Only",
    filterKeyMapping: {
        true: "all_person_committees",
        false: "all_person_committee",
    },
})

export const StafferMajorityMinorityFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}

StafferMajorityMinorityFilter.propTypes = defaultPropTypes
StafferMajorityMinorityFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "StafferMajorityMinorityFilter",
    filterKey: "comstaffertype__in",
    displayLabel: "Committee Staff",
    enumItems: DjangIO.app.person.types.ComStafferType.region_supported_items().filter((item) =>
        [
            DjangIO.app.person.types.ComStafferType.Minority.value,
            DjangIO.app.person.types.ComStafferType.Majority.value,
        ].includes(item.value),
    ),
    sortBy: enumOrderSort,
}
